'use client'

import CloseIcon from '@mui/icons-material/Close'
import { Box, Dialog, DialogContent, IconButton, SxProps } from '@mui/material'

interface ImageViewerDialogProps {
  imageUrl: string | null
  onClose: () => void
}

export default function ImageViewerDialog({
  imageUrl,
  onClose,
}: ImageViewerDialogProps) {
  return (
    <Dialog open={Boolean(imageUrl)} onClose={onClose} maxWidth="md" fullWidth>
      <Box sx={dialogBoxStyle}>
        <IconButton onClick={onClose} sx={closeIconStyle}>
          <CloseIcon />
        </IconButton>
        <DialogContent sx={dialogContentStyle}>
          <Box
            component="img"
            src={imageUrl || ''}
            alt="preview"
            sx={imageStyle}
          />
        </DialogContent>
      </Box>
    </Dialog>
  )
}

const dialogBoxStyle: SxProps = {
  position: 'relative',
}

const closeIconStyle: SxProps = {
  position: 'absolute',
  top: 8,
  left: 8,
  backgroundColor: 'rgba(0,0,0,0.6)',
  color: '#fff',
  zIndex: 1,
  '&:hover': { backgroundColor: 'rgba(0,0,0,0.8)' },
}

const dialogContentStyle: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto',
}

const imageStyle: SxProps = {
  maxWidth: '100%',
  maxHeight: '80vh',
}
